import { render, staticRenderFns } from "./CartGratuity.vue?vue&type=template&id=70d04429&scoped=true&"
import script from "./CartGratuity.vue?vue&type=script&lang=js&"
export * from "./CartGratuity.vue?vue&type=script&lang=js&"
import style0 from "./CartGratuity.vue?vue&type=style&index=0&id=70d04429&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../nonspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d04429",
  null
  
)

/* custom blocks */
import block0 from "./CartGratuity.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

component.options.__file = "CartGratuity.vue"
export default component.exports